import React, { createContext, useState, useEffect, useContext } from 'react';
import * as auth from '../services/auth';
import api from '../services/api';
import { Login } from '../services/auth';
import { useHistory } from 'react-router-dom';
import {ObterMenu} from '../services/grupoService'

interface User {
  nome: string;
  email: string;
  id: string;
  acessos: any[];
  inserirMotoristasAdicionaisViagem: boolean;
}


interface Permissoes {
  paginas: any[];
}

interface AuthContextData {
  signed: boolean;
  user: User | null;
  permissoes: Permissoes | null;
  signIn(data: Login): Promise<void>;
  signOut(): void;
} 

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const isSigned = () => localStorage.getItem('user') !== null;

export const AuthProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [permissoes, setPermissoes] = useState<Permissoes | null>(null);
  const history = useHistory();

  useEffect(() => {
    
    function loadLocalStorageData() {
      const storageUser = localStorage.getItem('user');
      const storageToken = localStorage.getItem('token');
      const storagePermissoes = localStorage.getItem('permissoes');

      if (storageUser) {
        api.defaults.headers['Authorization'] = `Bearer ${storageToken}`;
        setUser(JSON.parse(storageUser));
      }
    }
    loadLocalStorageData();


  }, []);

  

  async function signIn(data: Login) {
    const response = await auth.signIn(data);


    if (response.data.hasError) return;


    const {
      nome,
      email,
      acessos,
      id,
      token: { accessToken, refreshToken },
      inserirMotoristasAdicionaisViagem
    } = response.data?.value;


    api.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    localStorage.setItem('token', accessToken);
    localStorage.setItem('rToken', refreshToken);

    setUser({ email, nome, acessos , id, inserirMotoristasAdicionaisViagem});
    localStorage.setItem('user', JSON.stringify({ email, nome, acessos, inserirMotoristasAdicionaisViagem }));

    var dados = await ObterMenu(acessos[0]);
    localStorage.setItem('permissoes', btoa(JSON.stringify(dados.data)));

    history.push('/');
    document.location.reload(true);
  }



  function signOut() {
    setUser(null);
    setPermissoes(null);
    localStorage.clear();
    history.push('/');
    document.location.reload(true);
  }

  return (
    <AuthContext.Provider value={{ signed: !!user, user, permissoes, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  return context;
}
export function ObterPermissoes(){
  const storagePermissoes = localStorage.getItem('permissoes');
  return JSON.parse(atob(storagePermissoes as string) as string);
}
 